import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewVacancyPageMenu = () => {
  const { getSingleEntityUrl } = useVacancyUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} exact />
    </SidebarStickyMenu>
  );
};

export default ViewVacancyPageMenu;
